import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../../../components/UserPageLayout";
import { decodeId } from "../../../../../../../../utils/hash";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../../../../../../context/AppContext";
import Join from "../../components/Join";
import Dashboard from "../../components/dashboard";

export default function Partner() {
    const { setPageTitle, setPageUserID, appData } = useAppContext();

    const { id } = useParams();
    const userId = id ? decodeId(id) : null;
    const [isUserPartner, setIsUserPartner] = useState(true);


    useEffect(() => {
        setPageUserID(userId);
        setPageTitle("Partner");
        
    }, [setPageTitle, setPageUserID, userId]);

    return (
        <UserPageLayout>
            {appData?.metadata?.features?.includes("affiliate") && (
            <div className="content-body">
                {
                    isUserPartner ? (
                        <Dashboard userId={userId} setIsUserPartner={setIsUserPartner}/>
                    ) : (
                        <Join userId={userId} setIsUserPartner={setIsUserPartner}/>
                    )

                }

            </div>
            )}
            {!appData?.metadata?.features?.includes("affiliate") && (
                <div className="container-fluid">
                    <div className="row justify-content-center align-items-center" style={{ height: "80vh" }}>
                        <div className="col-auto text-center">
                            <div className="alert alert-warning mb-3" role="alert">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                Partner program is not enabled on this platform.
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </UserPageLayout>
    );
}